import { Navigate, Route, Routes } from "react-router-dom";
import { InheritanceReuse } from "@/features/inheritanceReuse/routes/InheritanceReuse";
import { useCurrentUserWithStatus } from "@/hooks/useCurrentUser";

/**
 * 相続後リユース検索は月額会員限定。
 *
 * 会員情報の取得中はルートを出し入れせず待機する（取得完了前に非会員扱いで退避させると、
 * 実際は会員でも直接アクセス・再読み込みで弾かれるため）。取得が確定して非会員だった場合のみ
 * ログイン後の既定着地（/feed）へ退避する。メニュー側は非会員に項目自体を出さない。
 */
export const InheritanceReuseRoutes: React.FC = () => {
  const { user, isLoading } = useCurrentUserWithStatus();

  if (isLoading) {
    return null;
  }
  if (!user?.isInheritanceReuseMonthlyMember) {
    return <Navigate to="/feed" replace />;
  }

  return (
    <Routes>
      <Route path="" element={<InheritanceReuse />} />
    </Routes>
  );
};
